export enum ApiPaths {
  LOGIN_EMAIL = 'v2/login/email',
  TRENDING_FEED = 'post/trending',
  POST_MY_FEED = 'post/myfeed/pages',
  POST_MY_GROUPS = 'group/page/mygroups',
  POST_JOINED_GROUPS = 'group/page/joinedgroups',
  ADMIN_REPORT = 'admin/report',
  ADMIN_REPORT_ACTION_TAKEN = 'admin/report/action-taken',
  USER_IMAGE = 'user/image',
  GET_USER = 'getUser',
  USER_POST = 'post/user',
  ME = 'me',
  ADD_EDIT_EDUCATION = 'user/education',
  USER_BANNER_MEDIA = 'user/banner',
  CREATE_POST = 'post',
  CREATE_POLL = 'poll',
  SIGNUP_EMAIL = 'v2/signup/email',
  SIGNUP_MOBILE = 'v3/signup/mobile',
  LOGIN_MOBILE = 'v3/login/mobile/request',
  RESEND_LOGIN_MOBILE = 'v2/login/mobile/request',
  LOGIN_MOBILE_VERIFICATION = 'v3/login/mobile/verify',
  SIGNUP_MOBILE_VERIFY = 'v3/signup/mobile/verify',
  SIGNUP_EMAIL_VERIFY = 'v2/signup/email/verify',
  SIGNUP_EMAIL_RESEND = 'signup/email/resend',
  SIGNUP_MOBILE_RESEND = 'v2/signup/mobile/resend',
  FOGOT_EMAIL_REQUEST = 'v2/password/forgot/request',
  FORGOT_PASSWORD_VERIFY_OTP = 'password/forgot/verify-otp',
  RESET_PASSWORD_REQUEST = 'v2/password/forgot/verify',
  TOPICS_CONTROLLER = 'topics',
  METADATA_CONTROLLER = 'metadata/topics',
  METADATA_CONTROLLER_POLL_CATEGORY = 'metadata/topics?topicType=POLL_CATEGORY',
  USER_CONTROLLER = 'user/topics',
  USER_EXPERIENCE = 'user/experience',
  UPDATE_PASSWORD = 'update/password',
  USER_BIO_UPDATE = 'user/bio',
  POST_MYFEED = 'post/myfeed',
  POST_MEDIA = 'post/media',
  USER_MEDIA = 'user/image',
  ADD_EDIT_EXPERIENCE = 'user/experience',
  POST_VOTE = 'vote',
  UPDATE_POLL_VOTE = 'update/pollvote',
  VOTE_USERS = 'vote/users',
  COMMENTS_POST_ID_PAGINATION = 'comments/page',
  COMMENTS = 'comment',
  FRIEND_REQUEST = 'friend/request',
  UNFRIEND = 'unfriend',
  GROUPS_FOLLOWING = 'group/following',
  FRIEND_RESPONSE = 'friend/response',
  FRIEND_PAGE_RESPONSE = 'friend/page/friends',
  INTERNAL_POST = 'internal/post',
  GROUP = 'group',
  GROUP_IMAGE = 'group/image',
  GROUP_BANNER = 'group/banner',
  FRIEND = 'friend',
  USER_PROFILE_SUMMARY = 'user/summary',
  UPDATE_USER_INTERESTS = '/user/topics',
  USER_BLOCK = 'user/block',
  USER_UN_BLOCK = 'user/unblock',
  POST_REMOVE = 'post/remove',
  USER_SEARCH = 'user/search',
  GET_ACTIVE_USER = 'user/active',
  USER_DELETE_REQUEST = '/user/delete-request',
  USER_PROFILE_FRIENDS_LIST = 'friends/list',
  USER_CAROUSEL = 'carousel',
  FEATURE_FLAG = 'feature/chat',
  User_Poll_Participants_List = 'users',
  GET_USER_MEDIA = 'post/media/user',
  User_Activity = 'useractivity',
  GET_ALL_USERS = 'groups',
  GET_GROUP_MEMBERS = 'group/members/page',
  USER_REPORT_ISSUE = "user/report-issue",
  LOG_OUT = "logout"
}

export enum ApiPaths_Notification {
  NOTIFICATION_LIST = 'notification/list',
  NOTIFICATION_LIST_PAGE = 'notification/page/list',
  NOTIFICATION_READ = 'notification/read',
  NOTIFICATION_READ_ALL = 'notification/read/all',
  NOTIFICATION_DELETE = 'notification',
  NOTIFICATION_OFF = 'notification/post/configuration',
  NOTIFICATION_COUNT = 'notification/count',
  NOTIFICATION_REGISTER = 'notification/register',
  NOTIFICATION_DEREGISTER = 'notification/deregister'
}

export enum ApiPaths_Groups {
  GROUP_POST = 'group/',
  GROUP_POST_BYID = 'group/post',
  GROUP_IMAGE_MEDIA = 'group/image',
  Group_BANNER_MEDIA = 'group/banner',
  GROUP_PROFILE = 'group/profile',
  MY_GROUPS_PAGE = 'group/page/mygroups',
  GROUP_MEMBERS = 'group/members/',
  JOINED_GROUPS_PAGE = 'group/page/joinedgroups',
  GROUP_SEARCH = 'group/search',
  GROUP_USER_SEARCH = 'search',
  GROUP_JOIN = 'group/join/',
  GROUP_UNJOIN = 'group/unjoin/',
  USER_GROUPS_LIST = 'group/page/associatedgroups',
  ALL_GROUPS_LIST = 'group/all',
  DELETE_GROUP_IMAGE = 'remove/group/image',
  DELETE_GROUP_BANNER = 'remove/group/banner',
  ADD_USER_TO_GROUP = 'group/addmembers/',
  REMOVE_USER_FROM_GROUP = 'group/removemember/',
  CREATE_GROUP_RELATION = 'group/creategrouprelation',
  GET_RELATED_GROUPS = 'group/getrelatedgroups',
  DELETE_GROUP_RELATION = 'group/deletegrouprelation',
  GET_RELATED_CHILD_GROUPS = 'group/getrelatedchildgroups'
}

export enum ApiPaths_Post {
  REPORT_POST = 'user/report/post',
  REMOVE_POST = 'post/remove',
  REPOST_POST = 'repost',
  DELETE_POST = 'post',
  USER_PIN_UNPIN_POST = 'user/post/pin',
  ADMIN_PIN_UNPIN_POST = 'admin/post/pin',
  SEARCH_BY_HASHTAG = 'post/searchbyhashtag',
  GET_HASHTAGS = 'hashTag'
}

export enum ApiPaths_Chat {
  UPDATE_USER_STATUS = 'user/updateStatus',
  GET_ALL_CONVERSATIONS = 'v2/userconversation/conversations',
  CREATE_CONVERSATION = 'v2/conversation',  
  GET_ALL_MESSAGES = 'v2/conversation',
  SEND_MESSAGE = 'conversation/message',
  SEND_GROUP_INVITE_MESSAGE = 'conversation/bulkmessage',
  DELETE_MESSAGE = 'conversation',
  DELETE_CONVERSATION = 'conversation',
  REACT_TO_MESSAGE = 'conversation/reaction',
  ADD_PARTICIPANT = 'conversation/user',
  UPDATE_DELIVERED_STATUS = 'conversation/deliveryStatus',
  UPDATE_READ_STATUS = 'conversation/readStatus',
  SIGNALR_NEGOTIATE = 'signalr/negotiate',
  SIGNALR_CONNECT = "signalr/connect",
  GET_ALL_GROUP_CONVERSATIONS = 'v2/groupConversation',
  GET_CONVERSATIONS_SNAPSHOT = 'conversationSnapshot',
  GET_GROUP_CONVERSATIONS_SNAPSHOT = 'groupConversationSnapshot',
  GET_GROUP_MESSAGES = 'groupConversation/page',
  CREATE_GROUP_CONVERSATION = 'groupConversation',  
  SEND_GROUP_MESSAGE = 'groupConversation/message',
  REACT_TO_GROUP_MESSAGE = 'groupConversation/reaction',
  UPDATE_GROUP_MESSAGE_DELIVERED_STATUS = 'groupConversation/deliveryStatus',
  UPDATE_GROUP_MESSAGE_READ_STATUS = 'groupConversation/readStatus',
  DELETE_GROUP_MESSAGE = 'groupConversation',
  DELETE_GROUP_CONVERSATION = 'groupConversation',
  REPORT_CONVERSATION = 'conversation/report',
  SEARCH_BY_MESSAGE = 'search/messages',
  LINK_PREVIEW = 'internal/getPreviewData'
}

export interface IUserSummaryDetails {
  userName: string;
  designation: string | null;
  address: string | null;
  website: string | null;
  id: string;
}
export interface IExperience {
  id?: string;
  companyName: string;
  designation: string;
  startDate: Date;
  endDate: Date;
  createdAt?: string;
  modifiedAt?: string;
}
export interface IEducation {
  id: string;
  school: string;
  degree: string;
  startDate: Date;
  endDate: Date;
  createdAt?: string;
  modifiedAt?: string;
}

export interface ITopic {
  id?: string;
  topicName?: string;
  createdAt?: string;
  modifiedAt?: string;
}
export interface IUserImage {
  id: string;
  fileName: string;
  originalFileKey: string;
  userId: string;
}

export interface IUserDetails {
  friend: any;
  friendRequestReceived: boolean;
  friendRequested: boolean;
  id: string;
  email: string;
  mobile: string;
  createdAt: string;
  emailVerified: boolean;
  experience: IExperience[];
  education: IEducation[] | [];
  bio: string;
  blocked: boolean;
  summary: IUserSummaryDetails | null;
  mobileVerified?: boolean;
  modifiedAt?: string | null;
  topics?: ITopic[];
  username: string | null;
  userImage?: IUserImage | null;
  userBanner?: IUserImage | null;
  postsCount: number;
  friendsCount: number;
  groupsCount: number;
  roles?: string[];
}

export interface IUserSummaryRequest {
  userName: string;
  designation: string | null;
  address: string | null;
  website: string | null;
}
export interface ISaveUserEducationDetailsResponse {
  error: boolean;
  message: string | null;
  code: null;
}

export interface ISaveUserEducationDetailsRequest {
  userEducation: [
    {
      id?: string;
      school: string;
      degree: string;
      startDate: Date | undefined | null;
      endDate: Date | undefined | null;
    }
  ];
}

export interface ISaveUserExperienceDetailsRequest {
  userExperience: [
    {
      id?: string;
      designation: string;
      companyName: string;
      startDate: Date | undefined | null;
      endDate: Date | undefined | null;
    }
  ];
}

export interface IInterestTopics {
  createdAt: string | undefined;
  id: string;
  modifiedAt: string | undefined;
  name: string;
}

interface IGroupImageDto {
  fileName: string;
  groupId: string;
  id: string;
  originalFileKey?: string;
  userId?: string;
}
interface IGroupBannerDto {
  fileName: string;
  groupId: string;
  id: string;
  originalFileKey: string;
  userId: string;
}

export interface IUserPost_User_Details {
  id: string;
  username: string;
  summary: {
    userName?: string;
    designation?: string;
    address?: string;
    website?: string;
    id?: string;
  };
  userImage: {
    id: string;
    fileName?: string;
    originalFileKey?: string;
    userId: string;
  };
}

export interface IUserPost_Media {
  id: string;
  fileName?: string;
  originalFileKey?: string;
  createdBy?: string;
  postId: string;
  timestamp?: Date;
  directUrl?: string;
}

export interface IPostsDto {
  id: string;
  group: IUserPost_Group_Details;
  user: IUserPost_User_Details;
  title: string;
  description: string;
  createdAt: string;
  modifiedAt?: string;
  deleted: boolean;
  mediaDtos: IUserPost_Media[];
  numComments: number;
  numVotes: number;
  voted: boolean;
}

export interface IUserPost_Group_Details {
  id: string;
  name: string;
  description: string;
  imageURL?: string;
  media?: string;
}

export interface IPostDetailedView {
  id: string;
  name: string;
  description: string;
  createdAt?: Date | null;
  modifiedAt?: string;
  active?: boolean;
  groupImageDto?: IGroupImageDto;
  groupBannerDto: IGroupBannerDto;
  postsCount?: number;
  membersCount?: number;
  postsDto?: IPostsDto[];
  owner?: boolean;
}

export interface IUserSummary {
  userName: string;
  designation?: string;
  address?: string;
  website?: string;
  id?: string;
}
export interface IUser {
  id: string;
  username: string;
  imageId?: string;
  summary: IUserSummary;
}

export interface IFriendResponse {
  user: IUser;
  createdAt: string;
}

export interface IFriend {
  avatarUri: any;
  user?: any;
  id: string;
  name: string;
  avatarId?: string;
}

export interface IMemberDetailedView {
  id: string;
  username: string;
  summary: IUserSummary;
  userImage: IUserImage;
  groupOwner: boolean;
}

export interface IGroupHeader {
  name: string;
  description: string;
  groupId: string;
}

export interface IGuestModeOptions {
  guestMode: boolean;
  navigateTo: string | null;
  menu: string | null;
  redirectTo: string | null;
  action: string | null;
  actionItem: object | string | null;
}